/**
 * Created by wwei on 2017-11-08.
 */
import React, { Component } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { Button } from 'antd';
import ServiceScale from './ServiceScale.js';
import moment from 'moment';
import Request from 'superagent';
import NotificationManager from '../../commons/CustomNotificationManager.js';
import ConfirmDialog from '../../commons/ConfirmDialog.js';
import {permissionCheck} from "../../commons/CommonUtils";
import {Permissions} from "../../commons/Constants";

class MultiTenantServiceDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            working: false,
            showScale: false,
            toScale: {}
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            working: false,
            showScale: false,
            toScale: {}
        })
    }

    componentWillUnmount() {
        if (this.timer !== 0) {
            console.log("destroy interval");
            clearInterval(this.timer);
            this.timer = 0;
        }
    }

    stateFormat = (cell) => {
        if (cell === "active") {
            return (
                <div className="serviceState" style={{backgroundColor: "#30a83a"}} title="active">
                </div>
            );
        } else if (cell === "busy") {
            return (
                <div className="serviceState" style={{backgroundColor: "#d11c23"}} title="busy">
                </div>
            );
        } else {
            return '';
        }
    }

    timeFormat = (cell) => {
        if (cell) {
            //return <div><Moment format="YYYY-MM-DD HH:mm:ss">{cell}</Moment> (<Moment fromNow>{cell}</Moment>)</div>
            return moment(cell).local().format("YYYY-MM-DD HH:mm:ss") + " (" + moment(cell).fromNow() + ")";
        } else {
            return '';
        }
    }

    connectionsFormat = (cell) => {
        return cell ? cell : 0;
    }

    openScale = () => {
        const {service} = this.props;
        this.setState({showScale: true, toScale: service});
    }

    openRestart = () => {
        this.restartModal.open();
    }

    openUndeploy = () => {
        this.undeployModal.open();
    }

    getAppID = () => {
        const {service} = this.props;
        if (service !== undefined && service.instances !== undefined && service.instances.length > 0) {
            return service.instances[0].marathonAppId;
        } else {
            return '';
        }
    }

    restart = () => {
        const {service} = this.props;
        const newService = {
            serviceName: service.serviceName,
            serviceVersion: service.serviceVersion.substr(1),
            version: service.version
        };
        this.setState({working: true});
        Request.post('/scaler/restart').withCredentials()
            .set('Accept', 'application/json')
            .send(newService)
            .end((error, response) => {
                this.setState({working: false});
                this.restartModal.close();
                if (error) {
                    console.error(error);
                    NotificationManager.error('Failed to restart service.');
                } else {
                    NotificationManager.success('Succeed to restart service.');
                    this.refreshStatus();
                }
            });
    }

    timer = 0;
    refreshStatus = () => {
        if (this.timer === 0) {
            console.log('Start interval check');
            this.timer = setInterval(() => {
                const {service} = this.props;
                this.props.refresh(service).then((newService) => {
                    if (newService &&
                        newService.targetInstances &&
                        newService.targetInstances === newService.instances.length) {
                        console.log('clear interval check');
                        clearInterval(this.timer);
                        this.timer = 0;
                    }
                });
            }, 5000);
        }
    }

    undeploy = () => {
        const {service} = this.props;
        const newService = {
            serviceName: service.serviceName,
            serviceVersion: service.serviceVersion.substr(1),
            version: service.version
        };
        this.setState({working: true});
        Request.post('/scaler/undeploy').withCredentials()
            .set('Accept', 'application/json')
            .send(newService)
            .end((error, response) => {
                this.setState({working: false});
                this.undeployModal.close();
                if (error) {
                    console.error(error);
                    NotificationManager.error('Failed to undeploy service.');
                } else {
                    NotificationManager.success('Succeed to undeploy service.');
                    this.props.refresh(null);
                }
            });
    }

    render() {
        const {service} = this.props;
        const {working, showScale, toScale} = this.state;
        const appId = this.getAppID();
        const isAllowScale = permissionCheck(Permissions.MultiTenant.SCALE);

        const options = {
            defaultSortName: 'rmid',
            defaultSortOrder: 'asc'
        }

        return (
            <div className="page-tenant-detail">
                <div>
                    <div className="page-close" onClick={this.props.close}>
                        <span className="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
                    </div>
                    <div className="panel-body">
                        <div className="form-group">
                            <b className="tenant-name">{service.serviceName}&nbsp;</b>
                        </div>
                        <div className="form-group">
                            <label className="col-sm-3 control-label">Service Version:</label>

                            <div className="col-sm-9">
                                <label className="control-label">{service.serviceVersion}&nbsp;</label>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="col-sm-3 control-label">Version:</label>

                            <div className="col-sm-9">
                                <label className="control-label">{service.version}&nbsp;</label>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="col-sm-3 control-label">Route Type:</label>

                            <div className="col-sm-9">
                                <label className="control-label">{service.routingType}&nbsp;</label>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="col-sm-3 control-label">Marathon App Id:</label>

                            <div className="col-sm-9">
                                <label className="control-label">{appId}&nbsp;</label>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="col-sm-3 control-label">Target Instance:</label>

                            <div className="col-sm-9">
                                <label className="control-label">{service.targetInstances}&nbsp;</label>
                            </div>
                        </div>
                    </div>

                    <Tabs>
                        <TabList>
                            <Tab>Instances</Tab>
                        </TabList>

                        <TabPanel>
                            <BootstrapTable data={ service.instances } options={ options }
                                            striped hover condensed>
                                <TableHeaderColumn dataField='state'
                                                   dataFormat={this.stateFormat}
                                                   width="80px"
                                                   headerAlign='left'
                                                   dataAlign="center">State</TableHeaderColumn>
                                <TableHeaderColumn dataField='rmid' isKey>ID</TableHeaderColumn>
                                <TableHeaderColumn dataField='marathonStartedAt'
                                                   dataFormat={this.timeFormat}>Started At</TableHeaderColumn>
                                <TableHeaderColumn dataField='wscount' hidden={service.routingType !== 'dm'}
                                                   dataFormat={this.connectionsFormat}>Connections</TableHeaderColumn>
                            </BootstrapTable>
                        </TabPanel>
                    </Tabs>

                    <div className="ant-modal-footer" style={{paddingLeft: 0, paddingRight: 0}}>
                        {isAllowScale &&
                        <div className="col-lg-8" style={{textAlign: 'left', padding: 0}}>
                            <Button key="submit" type="primary" size="large" loading={working}
                                    disabled={!service.canScale} onClick={this.openScale}>
                                Scale
                            </Button>
                            <Button key="cancel" size="large" loading={working} onClick={this.openRestart}>
                                Restart
                            </Button>
                        </div>
                        }
                        {isAllowScale &&
                            <div className="col-lg-4" style={{padding: 0}}>
                                <Button type="danger" size="large" loading={working} onClick={this.openUndeploy}>
                                    Undeploy
                                </Button>
                            </div>
                        }
                    </div>

                    <ServiceScale service={toScale} show={showScale} onSuccess={this.refreshStatus}/>
                    <ConfirmDialog ref={modal => {this.restartModal = modal}}
                                   title="Restart Service"
                                   promptText="Are you sure you want to restart all instances of this service?"
                                   cancelBtn="Cancel" confirmBtn="Restart"
                                   operate={this.restart}/>
                    <ConfirmDialog ref={modal => {this.undeployModal = modal}}
                                   title="Undeploy Service" confirmBtnType="danger"
                                   promptText="Are you sure you want to undeploy all instances of this service?"
                                   cancelBtn="Cancel" confirmBtn="Undeploy"
                                   operate={this.undeploy}/>
                </div>
            </div>
        );
    }
}

export default MultiTenantServiceDetail;


// WEBPACK FOOTER //
// ./src/modules/multi-tenanted-service/MultiTenantServiceDetail.js